import { SpringPagination } from '../../shared/interfaces/SpringPagination';
import {
  ChallengeInfo,
  LeaderboardRowInfo,
} from '../interfaces/leaderboard/LeaderboardRowInfo';
import { LeaderboardListFilters } from '../interfaces/leaderboard/LeaderboardListFilters';
import { getFilteredTruthyFieldsObj } from '../../shared/utils/sortingAndGroupingUtil';
import { apiService } from '../../shared/services/apiService';

type GetLeaderboardListResponse = SpringPagination<LeaderboardRowInfo[]>;

export const leaderboardService = {
  async getChallengeInfo(challengeId: number): Promise<ChallengeInfo> {
    const response = await apiService.get(`/api/public/challenges/${challengeId}/info`);

    return response.data;
  },

  async getLeaderboardList(
    challengeId: number,
    params: LeaderboardListFilters,
  ): Promise<GetLeaderboardListResponse> {
    const filteredParams = getFilteredTruthyFieldsObj(params);

    const response = await apiService.post(
      `/api/public/challenges/${challengeId}/leader-board`,
      filteredParams,
    );

    return response.data;
  },
};
